import "./App.css";
import React from "react";
import Content from "./components/Content/Content";
import { Router, Route, browserHistory } from "react-router";
import Details from "./components/PlayerSpecific";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import SignUp from "./components/UAM/SignUp/SignUp";
import Signin from "./components/UAM/Signin/Signin";
import ForgotPassword from "./components/UAM/ForgotPassword/ForgotPassword";
import ConfirmationSignup from "./components/UAM/ConfirmationSignup/ConfirmationSignup";
import LineupHome from "./components/LineupHome/LineupHome";
import Notifications from "./components/Notifications/Notifications";
import { onMessageListener } from "./firebase";
import ReactNotificationComponent from "./components/Notifications/ReactNotification";

import RequestAccountDeletion from "./components/RequestAccountDeletion/RequestAccountDeletion";

const RedirectToApp = () => {
  window.location.href = "/app";
  return null;
};

function App(props) {
  const [show, setShow] = React.useState(false);
  const [notification, setNotification] = React.useState({
    title: "",
    body: "",
  });
  console.log(show, notification);

  onMessageListener()
    .then((payload) => {
      alert("Message Received")
      console.log("message received:: ", payload);
      setShow(true);
      setNotification({
        title: payload.data.title,
        body: payload.data.body,
        league: payload.data.league,
        platform: payload.data.platform,
        slateID: payload.data.slateID,
        sport: payload.data.sport,
        season: payload.data.season,
      });

    })
    .catch((err) => console.log("failed: ", err));

  if (process.env.REACT_APP_ENV === "production") {
    console.log = () => { };
    console.groupCollapsed = () => { };
    console.groupEnd = () => { };
    console.error = () => { };
  }
  console.log("Current Environment", process.env.REACT_APP_ENV);
  console.log("PROPS", props);

  return (
    <>
      <Provider store={store}>
        {/* {console.log("Store", store)} */}
        <PersistGate loading={null} persistor={persistor}>
          <Router history={browserHistory}>
            <Route path={"/"} exact component={RedirectToApp} />
            <Route exact path={"/app"} component={Content} />
            <Route path={"/app/signin"} component={Signin} />
            <Route exact path={"/app/signup"} component={SignUp} />
            <Route
              exact
              path={"/app/deleteaccount"}
              component={RequestAccountDeletion}
            />
            <Route
              exact
              path={"/app/confirmsignup"}
              component={ConfirmationSignup}
            />
            <Route
              exact
              path={"/app/forgotpassword"}
              component={ForgotPassword}
            />
            <Route path={"/app/:league/player/:id"} component={Details} />
            <Route
              exact
              path={"/app/:league/:slateid/lineups/recommendations"}
              component={LineupHome}
            />
            <Route
              exact
              path={"/app/:league/:slateid/lineups/auto"}
              component={LineupHome}
            />
            <Route
              exact
              path={"/app/:league/:slateid/mylineups"}
              component={LineupHome}
            />
          </Router>
          {show ? (
            <ReactNotificationComponent
              title={notification.title}
              body={notification.body}
              league={notification.league}
              platform={notification.platform}
              slateID={notification.slateID}
              sport={notification.sport}
              season={notification.season}

            />
          ) : (
            <></>
          )}
          <Notifications />
        </PersistGate>
      </Provider>

    </>
  );
}

// <Route path="*" component={NotFound} />
export default App;
